import { cloneDeep } from "lodash";

export const setActiveContentAllowOtherOption = ({
  contents,
  activeContentId,
  allowOtherOption,
}) => {
  return contents.map((content) => {
    if (content.id === activeContentId) {
      content.allowOtherOption = allowOtherOption;
    }

    return cloneDeep(content);
  });
};

export default setActiveContentAllowOtherOption;
